/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {showTable, tableSave} from '../../common/tables/actions';

class TablesSmall extends React.Component {

    static propTypes = {
        tables: React.PropTypes.object,
        selectedProducts: React.PropTypes.object,
        showTable: React.PropTypes.func,
        tableSave: React.PropTypes.func
    };

    constructor(props) {
        super(props);
        this.manageTable = this.manageTable.bind(this);
    }

    manageTable(uuid) {
        const {showTable, tableSave, selectedProducts, msg} = this.props;
        if (selectedProducts.size > 0) {
            tableSave(uuid, msg);
        } else {
            showTable(uuid);
        }
    }

    render() {
        const {tables} = this.props;

        if (!!tables.has(1)) {
            return null;
        }

        const filterTable = tables.filter(t => t.get('open')).sortBy(t => t.get('lastAccess')).reverse().slice(0, 4);
        return (
            <section id="tables" className="pageCashbox-tables-container">
                {filterTable.map(table =>
                  <div className="pageCashbox-tables-table">
                    <div className="boxBtn color-white text-l"
                         onClick={() => this.manageTable(table.get('uuid'))}
                         key={`table-small-${table.get('uuid')}`}>
                        <div className="boxBtn-inner">
                            <span>{table.get('name')}</span>
                        </div>
                    </div>
                  </div>
                )}
            </section>

        );
    }
}

export default connect(state=> ( {
    tables: state.categories.get('tables'),
    selectedProducts: state.categories.get('selectedProducts')
}), {showTable, tableSave})(TablesSmall);



// WEBPACK FOOTER //
// ./src/browser/tables/TablesSmall.js